export default __webpack_public_path__ + "static/Domino-del-Plata-afbdf215ea567c95805af0aa1d53a2f6.jpg";